// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabs li[aria-selected="true"] {
  color: #0b2d71 !important;
  font-weight: 600;
  border: 4px solid #fff;
  border-width: 0 0 4px;
  border-bottom: #0b2d71 4px solid;
}
div.tabbed > ul.tabs {
  margin: 0;
  padding: 0;
  text-align: left;
}
.breadcrumb-link {
  color: #0b2d71;
  cursor: pointer;
  text-decoration: underline;
}

.breadcrumb-nav {
  padding: 8px 16px 6px;
}

.breadcrumb-nav .breadcrumb {
  padding-bottom: 0;
  margin-bottom: 0;
}
.search-icon {
  font-size: 16px;
  line-height: 16px;
  width: 16px;
  height: 16px;
}
.slurry-col-ufid {
  width: 100px;
}
.slurry-col-status {
  width: 120px;
}
.slurry-col-created-date {
  width: 140px;
}
.slurry-col-created-by {
  width: 140px;
}
.slurry-col-comments {
  max-width: 200px;
}
.slurry-col-actions {
  width: 130px;
  white-space: nowrap;
}
.slurry-comments-cell {
  max-width: 300px;
  word-break: break-word;
}
.slurry-row {
  cursor: pointer;
}
.slurry-row:hover {
  background-color: #eef4fb;
}
.slurry-row:focus {
  outline: 2px solid #2a6fb0;
  outline-offset: -2px;
}

/*Slurry and spacer service company data */
.scd-section {
  border-bottom: 1px solid #cdd8e3;
  padding-bottom: 0.75rem;
}
.scd-section-title {
  font-weight: 700;
  font-size: 0.95rem;
  margin-bottom: 0.5rem;
  text-align: left;
}
.scd-entry {
  padding-left: 0.25rem;
}
.scd-delete-icon {
  color: #c0392b;
  font-weight: bold;
  cursor: pointer;
  font-size: 1rem;
  line-height: 1;
}
/* Disable delete icons and gray out content when service company data is read-only */
.scd-edit-fieldset:disabled .scd-delete-icon {
  pointer-events: none;
  opacity: 0.4;
  cursor: not-allowed;
}
.scd-edit-fieldset:disabled {
  opacity: 0.85;
}
.scd-input-sm {
  width: 90px !important;
}
.scd-input-md {
  width: 200px !important;
}
.scd-notes-input {
  width: 340px !important;
}
.scd-rpm-table th,
.scd-rpm-table td {
  padding: 2px 4px;
  vertical-align: middle;
  white-space: nowrap;
}
.scd-rpm-input {
  width: 60px !important;
  padding: 2px 4px !important;
  font-size: 0.8rem !important;
}
.scd-section > button {
  display: block;
  margin-left: 0 !important;
  margin-right: auto !important;
  text-align: left;
}
.scd-entry .d-flex {
  gap: 0.75rem !important;
  row-gap: 0.5rem !important;
}
select.auto-size,
select.auto-size.form-control {
  display: inline-block;
  width: auto !important;   
  height: auto;
  vertical-align: middle;
  flex: 0 0 auto;             /* prevent flex from stretching it */
  box-sizing: content-box;
}
/* Materials QAQC grid: size columns based on content (auto layout) */
.materials-qaqc-grid {
  overflow-x: auto; /* allow horizontal scroll if content is wider than container */
}
.materials-qaqc-grid table {
  table-layout: auto; /* allow columns to size based on their content */
  width: 100%;
}
/* Default: allow cells to wrap so narrow content doesn't force huge widths */
.materials-qaqc-grid table thead th,
.materials-qaqc-grid table tbody td {
  white-space: normal;
  vertical-align: middle;
}
/* Key columns that should size to their content and not wrap (Material Name / Type / Container) */
.materials-qaqc-grid table thead th:nth-child(1),
.materials-qaqc-grid table tbody td:nth-child(1),
.materials-qaqc-grid table thead th:nth-child(2),
.materials-qaqc-grid table tbody td:nth-child(2),
.materials-qaqc-grid table thead th:nth-child(3),
.materials-qaqc-grid table tbody td:nth-child(3) {
  white-space: nowrap; /* keep these on a single line so width reflects content */
}
/* Numeric and short columns can be narrower; use small min-width so they stay readable */
.materials-qaqc-grid table thead th:nth-child(n+4),
.materials-qaqc-grid table tbody td:nth-child(n+4) {
  min-width: 80px;
}
`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/project-details/project-details.component.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,gCAAgC;AAClC;AACA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA,0CAA0C;AAC1C;EACE,gCAAgC;EAChC,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;AACA,qFAAqF;AACrF;EACE,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;;EAEE,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;;EAEE,qBAAqB;EACrB,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;EACtB,cAAc,cAAc,oCAAoC;EAChE,uBAAuB;AACzB;AACA,qEAAqE;AACrE;EACE,gBAAgB,EAAE,+DAA+D;AACnF;AACA;EACE,kBAAkB,EAAE,iDAAiD;EACrE,WAAW;AACb;AACA,6EAA6E;AAC7E;;EAEE,mBAAmB;EACnB,sBAAsB;AACxB;AACA,kGAAkG;AAClG;;;;;;EAME,mBAAmB,EAAE,0DAA0D;AACjF;AACA,yFAAyF;AACzF;;EAEE,eAAe;AACjB","sourcesContent":[".tabs li[aria-selected=\"true\"] {\n  color: #0b2d71 !important;\n  font-weight: 600;\n  border: 4px solid #fff;\n  border-width: 0 0 4px;\n  border-bottom: #0b2d71 4px solid;\n}\ndiv.tabbed > ul.tabs {\n  margin: 0;\n  padding: 0;\n  text-align: left;\n}\n.breadcrumb-link {\n  color: #0b2d71;\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.breadcrumb-nav {\n  padding: 8px 16px 6px;\n}\n\n.breadcrumb-nav .breadcrumb {\n  padding-bottom: 0;\n  margin-bottom: 0;\n}\n.search-icon {\n  font-size: 16px;\n  line-height: 16px;\n  width: 16px;\n  height: 16px;\n}\n.slurry-col-ufid {\n  width: 100px;\n}\n.slurry-col-status {\n  width: 120px;\n}\n.slurry-col-created-date {\n  width: 140px;\n}\n.slurry-col-created-by {\n  width: 140px;\n}\n.slurry-col-comments {\n  max-width: 200px;\n}\n.slurry-col-actions {\n  width: 130px;\n  white-space: nowrap;\n}\n.slurry-comments-cell {\n  max-width: 300px;\n  word-break: break-word;\n}\n.slurry-row {\n  cursor: pointer;\n}\n.slurry-row:hover {\n  background-color: #eef4fb;\n}\n.slurry-row:focus {\n  outline: 2px solid #2a6fb0;\n  outline-offset: -2px;\n}\n\n/*Slurry and spacer service company data */\n.scd-section {\n  border-bottom: 1px solid #cdd8e3;\n  padding-bottom: 0.75rem;\n}\n.scd-section-title {\n  font-weight: 700;\n  font-size: 0.95rem;\n  margin-bottom: 0.5rem;\n  text-align: left;\n}\n.scd-entry {\n  padding-left: 0.25rem;\n}\n.scd-delete-icon {\n  color: #c0392b;\n  font-weight: bold;\n  cursor: pointer;\n  font-size: 1rem;\n  line-height: 1;\n}\n/* Disable delete icons and gray out content when service company data is read-only */\n.scd-edit-fieldset:disabled .scd-delete-icon {\n  pointer-events: none;\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n.scd-edit-fieldset:disabled {\n  opacity: 0.85;\n}\n.scd-input-sm {\n  width: 90px !important;\n}\n.scd-input-md {\n  width: 200px !important;\n}\n.scd-notes-input {\n  width: 340px !important;\n}\n.scd-rpm-table th,\n.scd-rpm-table td {\n  padding: 2px 4px;\n  vertical-align: middle;\n  white-space: nowrap;\n}\n.scd-rpm-input {\n  width: 60px !important;\n  padding: 2px 4px !important;\n  font-size: 0.8rem !important;\n}\n.scd-section > button {\n  display: block;\n  margin-left: 0 !important;\n  margin-right: auto !important;\n  text-align: left;\n}\n.scd-entry .d-flex {\n  gap: 0.75rem !important;\n  row-gap: 0.5rem !important;\n}\nselect.auto-size,\nselect.auto-size.form-control {\n  display: inline-block;\n  width: auto !important;   \n  height: auto;\n  vertical-align: middle;\n  flex: 0 0 auto;             /* prevent flex from stretching it */\n  box-sizing: content-box;\n}\n/* Materials QAQC grid: size columns based on content (auto layout) */\n.materials-qaqc-grid {\n  overflow-x: auto; /* allow horizontal scroll if content is wider than container */\n}\n.materials-qaqc-grid table {\n  table-layout: auto; /* allow columns to size based on their content */\n  width: 100%;\n}\n/* Default: allow cells to wrap so narrow content doesn't force huge widths */\n.materials-qaqc-grid table thead th,\n.materials-qaqc-grid table tbody td {\n  white-space: normal;\n  vertical-align: middle;\n}\n/* Key columns that should size to their content and not wrap (Material Name / Type / Container) */\n.materials-qaqc-grid table thead th:nth-child(1),\n.materials-qaqc-grid table tbody td:nth-child(1),\n.materials-qaqc-grid table thead th:nth-child(2),\n.materials-qaqc-grid table tbody td:nth-child(2),\n.materials-qaqc-grid table thead th:nth-child(3),\n.materials-qaqc-grid table tbody td:nth-child(3) {\n  white-space: nowrap; /* keep these on a single line so width reflects content */\n}\n/* Numeric and short columns can be narrower; use small min-width so they stay readable */\n.materials-qaqc-grid table thead th:nth-child(n+4),\n.materials-qaqc-grid table tbody td:nth-child(n+4) {\n  min-width: 80px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
